import './app.js'
import CamperAbstract from './camper-abstract.js'
import CamperForm from './camper-form.js'

//Camper Form
CamperForm.init( true )

//init abstracts
CamperAbstract.init()
